import { render, staticRenderFns } from "./PrescriptionDetails.vue?vue&type=template&id=125cae46"
import script from "./PrescriptionDetails.vue?vue&type=script&lang=js"
export * from "./PrescriptionDetails.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionDetails.vue?vue&type=style&index=0&id=125cae46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports